<nav class="navbar navbar-expand-sm bg-dark navbar-dark">

    <ul class="navbar-nav mr-auto">
      <li class="nav-item" >
        <a class="nav-link" routerLink="/menu" #menu>
        Menu</a>
      </li>
    </ul>

    <ul class="navbar-nav">
      <li class="nav-item" *ngIf="!loggedIn()">
        <a class="nav-link" routerLink="/signup" #signup>
        Sign up</a>
      </li>
      <li class="nav-item" *ngIf="!loggedIn()">
        <a class="nav-link" routerLink="/login" #login>
        Log in</a>
      </li>
      <li class="nav-item" *ngIf="loggedIn()">
        <a class="nav-link" style="cursor: pointer;" (click)="logOut()" #logout>
        Log out</a>
      </li>
    </ul>
  </nav>